export default "__VITE_ASSET__adf53749__"